import React from 'react';
import FacebookIcon from 'images/icons/social/facebook.svg?react-svg';
import Button from './base';

const FacebookButton = props => (
  <Button variant="facebook" Icon={FacebookIcon} {...props} />
);

export default FacebookButton;
